import { EntityScheduleType } from '@common/models/Enums';
import { BaseEntitySchedulePreference } from '@common/models/Schedule/BaseEntitySchedulePreference';
import { defaultTo } from 'lodash';
/**
 * This class represents the base of Schedule Preferences for both vets and templates for the preferences that are on ProcessHospitalScheduleModel which represent
 * the unmodified (unprocessed) schedule preferences. They will be on the base of the ProcessedHospitalScheduleModel and can be used to know what a preference or override was before it got modifed into a ComputedSchedulePreference
 *
 * recall: there are for schedule preference tables, two for normal preferences, and two for overrides.  So this is for normal preferences and the override version of this is for override preferences.
 */
export class EntitySchedulePreference extends BaseEntitySchedulePreference {
  entityPreferenceId: number;
  entityId: number;
  hospitalId: number;
  entityType: EntityScheduleType;
  uniqueId: string;
  rowVersion: string;

  constructor(init: EntitySchedulePreference) {
    super(init);

    this.entityPreferenceId = init.entityPreferenceId;
    this.entityId = init.entityId;
    this.hospitalId = init.hospitalId;
    this.entityType = init.entityType;
    this.uniqueId = `${this.entityPreferenceId}_${this.entityType}`;
    this.rowVersion = defaultTo(init?.rowVersion, '');
  }

  /**
   * Instantiate a new default EntitySchedulePreference and optional spread in fields with specific values
   * @param init
   * @returns
   */
  static createNewEntitySchedulePreference(
    init?: Partial<EntitySchedulePreference>,
  ): EntitySchedulePreference {
    const fields: EntitySchedulePreference = {
      entityPreferenceId: 0,
      entityId: 0,
      hospitalId: 0,
      entityType: EntityScheduleType.Veterinarian,
      uniqueId: '0_0',
      schedulePreferenceId: 0,
      startTime: '00:00:00',
      endTime: '00:00:00',
      dayOfWeek: 0,
      scheduleBlockTypeId: 0,
      scheduleBlockTypeName: '',
      scheduleBlockTypeColor: '',
      scheduleBlockIsOverrideType: false,
      rowVersion: '',
    };

    const combinedInit: EntitySchedulePreference = {
      ...fields,
      ...init,
    };

    return new EntitySchedulePreference(combinedInit);
  }
}
